import styles from './cart-item.module.less';
import { useRef, useState } from 'react';
import ButtonText from '../../../components/button/button-text/ButtonText';
import extraStyles from './extra-amount-cart-item.module.less';
import { useProject } from '../../project-hooks/useProject';
import { InputTextLike } from '@sb1/ffe-form-react';

export const ExtraAmountCartItem = ({ updateExtraAmount }) => {
    const textFieldRef = useRef();
    const project = useProject();
    const showChangeCountButtons = !project?.profile?.hideChangeCountButtons;

    const [extraAmount, setExtraAmount] = useState('');

    const onChangeExtraAmount = (value) => {
        const amountString = value.replace(/[^0-9.]/g, '').match(/^[0-9]+/);
        if (amountString) {
            setExtraAmount(amountString);
            updateExtraAmount(parseInt(amountString, 10));
        } else {
            setExtraAmount('');
            updateExtraAmount(0);
        }
    };
    return (
        <div className={[styles.item, !showChangeCountButtons ? styles.hideCountButtons : ''].join(' ')}>
            <span className={styles.rewardTitle}>Valgfritt beløp</span>

            <span className={[styles.rewardPrice, extraStyles.inputContainer].join(', ')}>
                <div>kr&nbsp;</div>
                <InputTextLike
                    labelClass={extraStyles.textField}
                    className={extraStyles.textField}
                    onChange={(evt) => onChangeExtraAmount(evt.target.value)}
                    onBlur={(evt) => onChangeExtraAmount(evt.target.value)}
                    value={extraAmount}
                    inputMode="number"
                    pattern="[0-9]*"
                    ref={textFieldRef}
                    ariaLabel={'Legg igjen et valgfritt beløp'}
                />
            </span>

            <ButtonText className={styles.rewardRemove} onClick={() => textFieldRef.current.focus()}>
                Endre
            </ButtonText>
            <div className={styles.itemQuantity}>&nbsp;</div>
        </div>
    );
};
